<template>
  <div>
    <div v-show="!isLoaded">
      <Loading ref="loadingSpinner"></Loading>
    </div>
    <div v-show="isLoaded">
      <b-overlay :show="busy" rounded="sm">
        <b-form @submit="SubmitForm">
          <div class="row">
            <div class="col">
              <div class="row">
                <div class="col">
                  <label>Wybrany bęben:</label>
                  <v-select label="name" :options="barrels" v-model="form.barrelId" :reduce="(x) => x.id"
                    :disabled="true"></v-select>
                </div>
              </div>
            </div>
            <div class="col">
              <DisplayRecipeCoating @selectedRecepie="SetNameAndInsertIngridients"
                :allowedRecipeTypes="allowedRecipesTypes" ref="recipe">
              </DisplayRecipeCoating>
            </div>
          </div>
          <hr />

          <div v-show="form.rawMaterialTypeGroup.length > 0 || form.selectedCouvertures.length > 0">
            <div class="card">
              <div class="card-header">
                <div class="row">
                    <h4>Produkty znajdujące się w kuwerturze</h4>
                </div>
              </div>
              <div class="card-body">
                <IngredientForCouverture v-for="rwTypeGroup in form.rawMaterialTypeGroup" :key="rwTypeGroup.id"
                  :rawMaterials="rawMaterials" :rawMaterialTypeGroup="rwTypeGroup" :counter="counter"
                  :recipeRef="$refs.recipe">
                </IngredientForCouverture>
              </div>
            </div>

            <div class="card mt-4">
              <div class="card-header">
                <div class="row">
                  <div class="col-8">
                    <h4>Dodane kuwertury</h4>
                  </div>
                  <div class="col-4">
                    <button type="button" class="btn btn-primary float-right" @click="AddCouvertureItem">
                      Dodaj kuwerturę
                    </button>
                  </div>
                </div>
              </div>
              <div class="card-body" v-show="form.selectedCouvertures.length > 0">
                <CouvertureIngredient v-for="couverture in form.selectedCouvertures" :key="couverture.id"
                  :couverture="couverture" @AddExistingCouvertureRemoveItem="RemoveCouvertureItem">
                </CouvertureIngredient>
              </div>
            </div>

            <div class="row">
              <div class="col align-self-end div-form-buttons-area">
                <button type="submit" class="btn-primary btn">Zapisz</button>
              </div>
            </div>
          </div>
        </b-form>
      </b-overlay>
    </div>
  </div>
</template>

<script>
import Loading from "../../components/Common/Loading";
import IngredientForCouverture from "../Production/IngredientForCouverture";
import DisplayRecipeCoating from "./Shared/DisplayRecipeCoating.vue";
import urlConfig from "../../mixins/url";
import toastr from "../../mixins/toastr";
import ProductionCommonMethods from "../../mixins/ProductionCommonMethods";
import axios from "axios";
import CouvertureIngredient from "./CouvertureIngredient";
import RawMaterialService from "../../services/rawMaterial.service";

export default {
  name: "CreateCompositionForBarrel",
  mixins: [urlConfig, toastr, ProductionCommonMethods],
  components: {
    Loading,
    IngredientForCouverture,
    DisplayRecipeCoating,
    CouvertureIngredient,
  },
  computed: {
    barrels() {
      return this.$store.state.productionHall.barrels;
    },
    rawMaterialTypes() {
      return this.$store.state.couvertureFormData.rawMaterialTypes;
    },
    productCouvertures() {
      return this.$store.state.couvertureFormData.recipes;
    },
    coatingProductTypes() {
      return this.$store.state.coatingProduct.type;
    },
    allowedRecipesTypes() {
      return [this.coatingProductTypes?.barrel]
    }
  },
  mounted() {
    this.$store.dispatch("getProductionHallData");
    this.form.millId = parseInt(this.$route.params.millId);
    this.GetAvaiableRawMaterials();
    this.form.barrelId = parseInt(this.$route.params.barrelId);
  },
  data() {
    return {
      busy: false,
      counter: 0,
      isLoaded: false,
      rawMaterials: [],
      form: {
        rawMaterialTypeGroup: [],
        selectedCouvertures: [],
        barrelId: 0,
      },
    };
  },
  methods: {
    GetAvaiableRawMaterials() {
      var that = this;
      RawMaterialService.getAvaiableRawMaterials()
        .then(function (res) {
          that.rawMaterials = that.CreateAvaiableRawMaterialList(res);
          that.isLoaded = true;
        })
        .catch(function (err) {
          console.log(err);
          var ref = that.$refs.loadingSpinner;
          ref.ShowErrorMessage("Wystąpił błąd aplikacji!", err);
          that.isLoaded = false;
        });
    },

    AddIngridients(ingridient) {
      // Produkty
      if (ingridient.materialType == 2) {
        let rawMaterialGroupItem = {
          rawMaterialType: this.GetRawMaterialType(ingridient.ingredientId),
          rawMaterials: [{ id: this.counter, selectedRawMaterial: {}, usedWeight: 0 }],
        };
        this.form.rawMaterialTypeGroup.push(rawMaterialGroupItem);
        this.counter = this.counter + 1;
      }
      // Kuwertury
      else {
        let couverture = {
          couverture: {},
          couvertureType: this.productCouvertures.filter(
            (x) => x.id == ingridient.ingredientId
          )[0],
          id: this.counter,
          weight: 0,
        };
        this.counter = this.counter + 1;
        this.form.selectedCouvertures.push(couverture);
      }
    },

    GetRawMaterialType(rawMaterilTypeId) {
      return this.rawMaterialTypes.filter((x) => x.id == rawMaterilTypeId)[0];
    },

    SetNameAndInsertIngridients(recipe) {
      this.isLoaded = false;
      this.form.rawMaterialTypeGroup = [];
      this.form.selectedCouvertures = [];

      if (recipe) {
        recipe.ingredients.forEach((x) => {
          this.AddIngridients(x);
        });
      }
      this.isLoaded = true;
    },

    SubmitForm(evt) {
      var ingredients = [];

      evt.preventDefault();
      var isValid = this.FormValidation();
      var that = this;
      if (isValid) {
        this.busy = true;
        var rawMaterialGroups = this.form.rawMaterialTypeGroup.filter(
          (x) => x.rawMaterialType.id != 0
        );

        rawMaterialGroups.forEach((rwg) => {
          rwg.rawMaterials.forEach((rw) => {
            if (rw.selectedRawMaterial.id) {
              ingredients.push({
                sourceId: rw.selectedRawMaterial.id,
                weight: parseFloat(rw.usedWeight),
                type: 2,
              });
            }
          });
        });

        var couvertures = this.form.selectedCouvertures
          .filter((x) => x.couverture.id)
          .map((x) => ({
            sourceId: x.couverture.id,
            weight: x.weight,
            type: 1,
          }));

        ingredients = ingredients.concat(couvertures);

        axios
          .post(this.url.serverUrl + this.url.Barrel.CreateCoatingProduct, {
            BarrelId: that.form.barrelId,
            name: that.$refs.recipe.selectedRecipe.name,
            ingredients: ingredients,
            recipeCoatingId: that.$refs.recipe.selectedRecipe.id,
          })
          .then(function () {
            that.DisplaySuccess("Sukces!", "Kuwertura została stworzona");
            window.location.href = "/#/Bebny/";
          })
          .catch(function (e) {
            that.busy = false;
            console.log(e);
          });
      }
    },

    ValidateWeightForRawMaterials() {
      var groups = this.form.rawMaterialTypeGroup;
      for (var i = 0; i < groups.length; i++) {
        var group = groups[i];
        var rawMaterials = group.rawMaterials;

        for (var j = 0; j < rawMaterials.length; j++) {
          var rawMaterialRow = rawMaterials[j];
          var avaiableWeight = rawMaterialRow.selectedRawMaterial.availableWeight;
          var usedWeight = parseFloat(rawMaterialRow.usedWeight);

          if (
            !usedWeight ||
            !rawMaterialRow.selectedRawMaterial ||
            rawMaterialRow.selectedRawMaterial.id == 0
          ) {
            var text = rawMaterialRow.selectedRawMaterial.name
              ? "Wpisana waga w produkcie " +
              rawMaterialRow.selectedRawMaterial.name +
              " jest nie prawidłowa."
              : "Wpisana waga w jednym z produktów jest nie prawidłowa.";

            this.DisplayError("Bład w kuwerturze", text);

            return false;
          }

          if (usedWeight && (usedWeight < 0 || usedWeight > avaiableWeight)) {
            this.DisplayError(
              "Bład w produkcie",
              "Wpisana waga w produkcie " +
              rawMaterialRow.selectedRawMaterial.name +
              " jest nie prawidłowa"
            );
            return false;
          }
        }
      }
      return true;
    },

    ValidateWeightForCouverture() {
      var couvertures = this.form.selectedCouvertures;
      for (var i = 0; i < couvertures.length; i++) {
        var couverutreRow = couvertures[i];
        var avaiableWeight = couverutreRow.couverture.totalWeight;
        var usedWeight = couverutreRow.weight;

        if (!usedWeight || usedWeight < 0 || usedWeight > avaiableWeight) {
          var text = couverutreRow.couverture.name
            ? "Wpisana waga kuwertury " +
            couverutreRow.couverture.name +
            " jest nie prawidłowa."
            : "Wpisana waga w jednej z kuwertur jest nie prawidłowa.";

          this.DisplayError("Bład w kuwerturze", text);
          return false;
        }
      }
      return true;
    },

    FormValidation() {
      var rawMaterialsWeight = this.ValidateWeightForRawMaterials();
      var couverturesWeight = this.ValidateWeightForCouverture();
      var isEmptyForm = this.CheckIfFormIsEmpty();

      return rawMaterialsWeight && couverturesWeight && !isEmptyForm;
    },

    CheckIfFormIsEmpty() {
      var rawMaterialsCount = this.form.rawMaterialTypeGroup.filter(
        (x) => x.rawMaterials
      ).length;
      var couvertureCount = this.form.selectedCouvertures.filter((x) => x.couverture.id)
        .length;
      var isEmptyForm = rawMaterialsCount == 0 && couvertureCount == 0;
      if (isEmptyForm) {
        var ref = this.$refs.loadingSpinner;
        ref.ShowErrorMessage("Błąd w formularzu", "Nie można wysłać pustego formularza");
      }
      return isEmptyForm;
    },
    AddNextPositionToCouvertureGroupList() {
      var rawMaterial = {
        id: this.counter,
        selectedRawMaterial: {
          id: 0,
          name: "",
          availableWeight: "",
          serialNumber: "",
        },
        usedWeight: 0,
      };
      this.form.rawMaterialTypeGroup.push({
        rawMaterialType: {},
        rawMaterials: [rawMaterial],
        id: this.counter,
      });
      this.counter = this.counter + 1;
    },
    AddCouvertureItem() {
      var couverture = this.CreateCouverture();
      couverture.id = this.counter;
      this.counter = this.counter + 1;
      this.form.selectedCouvertures.push(couverture);
    },
    RemoveCouvertureItem(couvertureId) {
      this.form.selectedCouvertures = this.form.selectedCouvertures.filter(
        (x) => x.id != couvertureId
      );
    }
  },
};
</script>
